import { createDraftSafeSelector, type PayloadAction } from "@reduxjs/toolkit";
import { DUMMY_FILTER } from "Data/Dummy/Filters";
import { createAppSlice } from "Data/Redux/Store";
import { produce } from "immer";
import {
	CertificateType, EapType, HttpAuthenticationType, type NetworkSecurityState, IpFilterRule,
	RtspAuthenticationType
} from "Interfaces";

const initialState: NetworkSecurityState = {
	securityOptions: {
		rtspAuthType: RtspAuthenticationType.OFF,
		encryptionType: "HTTP & HTTPS",
		httpAuthType: HttpAuthenticationType.BASIC
	},
	sslCertificates: [
		{
			type: CertificateType.SSL,
			name: ""
		},
		{
			type: CertificateType.DCV_HTTP,
			name: ""
		}
	],
	ipFiltering: {
		ipFilterEnabled: false,
		ipFilterRule: IpFilterRule.ALLOW,
		filters: DUMMY_FILTER
	},
	ieeeOptions: {
		eapolVersion: 1,
		eapType: EapType.TLS,
		enabled: true,
		id: ""
	},
	certificates: [
		{
			type: CertificateType.CA,
			name: ""
		},
		{
			type: CertificateType.CLIENT,
			name: ""
		},
		{
			type: CertificateType.KEY,
			name: ""
		}
	]
};

// #region Reducers

export const setNetworkSecuritySettingsReducer = (
	state: NetworkSecurityState, action: PayloadAction<NetworkSecurityState>
) => {
	if (!action.payload) {
		return;
	}

	return produce(action.payload, draft => {
		delete draft.ieeeOptions.password;
		delete draft.ieeeOptions.clientKeyPassword;
	});
};

// #endregion

// #region Selectors

const getNetworkSecuritySettings = (state: NetworkSecurityState): NetworkSecurityState => {
	return produce(state, draft => {
		draft.ieeeOptions.password = "";
		draft.ieeeOptions.clientKeyPassword = "";
	});
};

// #endregion

const networkSecuritySlice = createAppSlice({
	name: "networkSecurity",
	initialState,
	reducers: {
		setNetworkSecuritySettingsAction: setNetworkSecuritySettingsReducer
	},
	selectors: {
		selectNetworkSecuritySettings: createDraftSafeSelector(
			(state) => state,
			getNetworkSecuritySettings
		)
	}
});

export default networkSecuritySlice;

export const { setNetworkSecuritySettingsAction } = networkSecuritySlice.actions;

export const { selectNetworkSecuritySettings } = networkSecuritySlice.selectors;
